<app-loading *ngIf="isLoading"></app-loading>
<div class="page">
  <header *ngIf="isAuthenticated" class="navbar navbar-expand-md navbar-dark">
    <div class="container-xl">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-menu">
        <span class="navbar-toggler-icon"></span>
      </button>
      <!-- <div class="card">
        <a href="." class="col-auto">
          <img src="assets/img/logoYeni.jpg" alt="Öztüre" class="navbar-brand-image" width="80" height="280">
        </a>
      </div> -->
      <div class="card">
        <div class="row row-0">
          <div class="col-auto">
            <img src="assets/img/logo-dash.png" class="rounded-start" alt="Shape of You" width="80" height="80">
          </div>
        </div>
      </div>
      <!-- <div class="col-auto">
        <div class="card card-sm">
          <a href="#" class="d-block"><img src="assets/img/logoYeni.jpg" class="card-img-top"></a>
        </div>
      </div> -->
      <div class="navbar-nav flex-row order-md-last">
        <div class="nav-item dropdown d-none d-md-flex mr-3">
          <a href="#" class="nav-link px-0" data-toggle="dropdown" tabindex="-1">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
              stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z"></path>
              <path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"></path>
              <path d="M9 17v1a3 3 0 0 0 6 0v-1"></path>
            </svg>
            <span *ngIf="duyuruCount > 0" class="badge bg-red">{{duyuruCount < 100 ? duyuruCount : "99+"}}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-right dropdown-menu-card">
            <div class="card">
              <div class="card-body">
                <div>
                  <a href="/duyurular" style="text-decoration: none;">
                    Duyurular
                  </a>
                </div>
                <div *ngIf="user.id === 1">
                  <a  href="/duyuru-ekle" style="text-decoration: none;">
                    Duyuru Ekle
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="nav-item dropdown">
          <a href="#" class="nav-link d-flex lh-1 text-reset p-0" data-toggle="dropdown">
            <span *ngIf="user!=null" class="avatar"
              [ngStyle]="{'background-image':'url('+user?.getProfilePic+')'}"></span>
            <div class="d-none d-xl-block pl-2">
              <div>{{user?.kullaniciAdi}}</div>
              <div class="mt-1 small text-muted">{{user?.typeName}}</div>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <!-- <a class="dropdown-item" href="#">
               <svg xmlns="http://www.w3.org/2000/svg" class="icon dropdown-item-icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"></path><path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path><circle cx="12" cy="12" r="3"></circle></svg>
               Action
             </a>
             <a class="dropdown-item" href="#">
               <svg xmlns="http://www.w3.org/2000/svg" class="icon dropdown-item-icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"></path><path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"></path><path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"></path><line x1="16" y1="5" x2="19" y2="8"></line></svg>
               Another action
             </a>-->
            <h6 class="dropdown-header">Şubeler</h6>
            <app-loading-input [dark]="true" *ngIf="subeler==null"></app-loading-input>

            <label class="dropdown-item clickable" *ngFor="let s of subeler"
              (click)="selectedBranch(s);$event.stopPropagation();"><span *ngIf="s.checked"><svg
                  xmlns="http://www.w3.org/2000/svg" class="icon icon-md" width="24" height="24" viewBox="0 0 24 24"
                  stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z"></path>
                  <path d="M5 12l5 5l10 -10"></path>
                </svg></span>&nbsp;&nbsp;{{s.isim}}</label>

            <div class="dropdown-divider"></div>

            <div class="dropdown-item">
              <label class="form-check">
                <input class="form-check-input" type="checkbox" [checked]="isOnayimdakiler"
                  (change)="setIsConfirm($event)">
                <span class="form-check-label">Sadece Onayımdakileri Göster</span>
              </label>
            </div>
            <div class="dropdown-item" (click)="netsisCariAktar()">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4" />
                <line x1="12" y1="13" x2="12" y2="22" />
                <polyline points="9 19 12 22 15 19" />
              </svg>&nbsp;
              Netsis'ten Carileri Aktar
            </div>

            <div class="dropdown-divider"></div>
            <div class="dropdown-item" (click)="showProfile()">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="12" cy="7" r="4" />
                <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
              </svg>&nbsp;
              Profilim
            </div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-item" (click)="logout()">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon dropdown-item-icon" width="24" height="24"
                viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z"></path>
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Çıkış Yap
            </div>
          </div>
        </div>
      </div>
      <div class="collapse navbar-collapse" id="navbar-menu">
        <div class="d-flex flex-column flex-md-row flex-fill align-items-stretch align-items-md-center">
          <ul class="navbar-nav">
            <li class="nav-item" [ngClass]="{'active':currentPage === menuItem.page}" (click)="selectMenu(menuItem)"
              *ngFor="let menuItem of publicMenuItems">
              <a class="nav-link" href="javascript:void(0);">
                <span class="nav-link-icon d-md-none d-lg-inline-block" [innerHTML]="getIconSvg(menuItem)">
                </span>
                <span class="nav-link-title">{{menuItem.name}}</span>
                <span *ngIf="menuItem.onaySayisi > 0" class="badge bg-red">{{menuItem.onaySayisi}}</span>
              </a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#navbar-docs" data-toggle="dropdown" role="button"
                aria-expanded="false">
                <span class="nav-link-icon d-md-none d-lg-inline-block">
                </span>
                <span class="nav-link-title">Lojistik</span>
              </a>
              <ul class="dropdown-menu dropdown-menu-columns  dropdown-menu-columns-3">
                <li *ngFor="let menuItem of lojistikMenuItems">
                  <div class="dropdown-item" (click)="selectMenu(menuItem)">{{menuItem.name}}</div>
                </li>
              </ul>
            </li>
            <li *ngIf="user?.kullaniciGrupId === 1" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#navbar-docs" data-toggle="dropdown" role="button"
                aria-expanded="false">
                <span class="nav-link-icon d-md-none d-lg-inline-block">
                </span>
                <span class="nav-link-title">Yönetim</span>
              </a>
              <ul class="dropdown-menu dropdown-menu-columns  dropdown-menu-columns-3">
                <li *ngFor="let menuItem of adminMenuItems">
                  <div class="dropdown-item" (click)="selectMenu(menuItem)">{{menuItem.name}}</div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
  <div class="container-xl d-flex flex-column justify-content-center" *ngIf="showConnectionError">
    <div class="empty">
      <p class="empty-title h3">Bağlantı Hatası</p>
      <p class="empty-subtitle text-muted">
        Bağlantı Hatası Oluştu
      </p>
      <div class="empty-action">
        <div class="btn btn-primary" (click)="refresh()">
          Tekrar Dene
        </div>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="container-fluid">
      <!-- <div class="page-header">
        <div class="row align-items-center">
          <div class="col-auto">
            <div class="page-pretitle">
              Dashboard
            </div>
            <h2 class="page-title">
              {{pageTitleKey}}
            </h2>
          </div>
        </div>
      </div> -->
      <ng-content></ng-content>
    </div>
    <footer class="footer footer-transparent">
      <div class="container">
        <div class="row text-center align-items-center flex-row-reverse">
          <div class="col-lg-auto ml-lg-auto">
            <ul class="list-inline list-inline-dots mb-0">
              <li class="list-inline-item"><a [href]="website" target="_blank" class="link-secondary">Contact</a></li>
            </ul>
          </div>
          <div class="col-12 col-lg-auto mt-3 mt-lg-0">
            {{name}} {{version}}. Copyright © {{year}} All Rights Reserved.
            <a [href]="website" target="_blank" class="link-secondary">Sedbim Bilişim Ltd.</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</div>